import { MailToSystemAdminSupportLink } from '../components/shared/MailToSystemAdminSupportLink';

export const AccessDenied = () => {
    return (
        <div className="px-4 pt-4">
            <h1>Access Denied</h1>
            <hr />
            <p>
                You have attempted to access a page that you are not authorized to view. If you have
                any questions, please contact your administrator at <MailToSystemAdminSupportLink />
            </p>
        </div>
    );
};
